<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-list d-lg-inline-block"></div>

            <section class="content table-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="request-title list-title">
                            <h1>Tableau de bord des dispenses par entreprise</h1>
                        </div>
                    </div>
                    <div>
                        <input
                            v-model="search"
                            placeholder="Filtrer par nom d'entreprise"
                            class="form-control mb-2"
                        >
                        <VueTable ref="vuetable"
                            :fields="fields"
                            :api-mode="false"
                            :data="statistics"
                            no-data-template="Aucune donnée disponible"
                            class="table table-striped table-bordered"
                        >
                            <template v-slot:enterprise="props">
                                <a href="#" @click.prevent="goToList(props.rowData.enterpriseId)">
                                    {{ props.rowData.enterpriseName }}
                                </a>
                            </template>

                            <template v-for="field in Object.keys(statusesToDisplay)" v-slot:[field]="props">
                                <span class="light" v-if="props.rowData[field] === 0" v-bind:key="`${props.rowData.enterpriseId}_${field}`">
                                    0
                                </span>
                                <a class="heavy" v-else href="#" @click.prevent="goToList(props.rowData.enterpriseId, field)" v-bind:key="`${props.rowData.enterpriseId}_${field}`">
                                    {{ props.rowData[field] }}
                                </a>
                            </template>
                        </VueTable>

                        <Paginator
                            :items.sync="enterprises"
                            :pagination.sync="pagination"
                            class="float-right"
                        />
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import VueTable from 'vuetable-2';
    import { debounce } from 'lodash';

    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import { fetchEnterprisesExemptionStatistics } from '@/service/api/exemptions.api';
    import { fetchEnterprises } from '@/service/api/enterprise.api';
    import Paginator from '@/components/Paginator.vue';

    export default {
        data() {
            return {
                enterprises: [],
                statistics: [],
                statusesToDisplay: {
                    draft: 'Demandes à compléter',
                    to_finalise: 'Demandes à finaliser',
                    to_validate: 'Demandes à valider',
                    to_abort: 'Demandes à abandonner',
                },
                pagination: {
                    currentPage: 1,
                    totalItems: null,
                    itemsPerPage: 10
                },
                search: '',
            }
        },
        computed: {
            fields() {
                const titleWidth = 40;
                const statusWidth = Math.floor((100 - titleWidth) / Object.keys(this.statusesToDisplay).length);

                return [
                    {
                        name: 'enterprise',
                        title: 'Entreprise',
                        width: `${titleWidth}%`
                    },
                    ...Object.entries(this.statusesToDisplay).map(([statusCode, statusTitle]) => ({
                        name: statusCode,
                        title: statusTitle,
                        titleClass: 'text-center',
                        dataClass: 'text-center',
                        width: `${statusWidth}%`
                    })),
                ];
            },
            page() {
                return this.pagination.currentPage;
            }
        },
        watch: {
            page() {
                this.fetchEnterprises();
            },
            enterprises(enterprises) {
                this.fetchStats(enterprises.map(({ id }) => id));
            },
            search() {
                this.pagination.currentPage = 1;
                this.debouncedFetchEnterprises();
            }
        },
        created() {
            this.debouncedFetchEnterprises = debounce(this.fetchEnterprises, 300)
            this.fetchEnterprises();
        },
        methods: {
            ...mapActions({
                setEnterpriseData: 'setEnterpriseData',
            }),
            async fetchEnterprises() {
                const { data } = await fetchEnterprises(this.pagination, this.search);
                this.enterprises = data.items;
                this.pagination.totalItems = data.totalItems;
            },
            async fetchStats(enterpriseIds) {
                const { data } = await fetchEnterprisesExemptionStatistics(enterpriseIds);
                this.statistics = Object.entries(data).map(([enterpriseId, stats]) => ({
                    enterpriseId,
                    enterpriseName: this.enterprises.find(({ id }) => id === +enterpriseId)?.name || '',
                    ...Object.keys(this.statusesToDisplay).reduce(
                        (acc, status) => ({ ...acc, [status]: stats[status] || 0}),
                        {}
                    ),
                })).sort(({ enterpriseName: nameA }, { enterpriseName: nameB }) => nameA.localeCompare(nameB));

                this.$refs.vuetable && this.$refs.vuetable.setData(this.statistics);
            },
            async goToList(enterpriseId, status = null) {
                await this.setEnterpriseData(this.enterprises.find(({ id }) => id === +enterpriseId));
                this.$router.push({ name: 'exemption-list', ...(status && { query: { status } }) });
            }
        },
        components: {
            Paginator,
            Sidebar,
            Footer,
            VueTable,
        }
    }
</script>

<style scoped lang="scss">
    a {
        color: $color-primary;

        &.heavy {
            font-weight: bold;
        }

        &:hover {
            color: lighten($color-primary, 20%);
        }
    }

    span.light {
        opacity: .4;
    }
</style>
